import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/Dashboard';
import UserManagement from './components/UserManagement';
import PalletSheets from './components/PalletSheets';
import PalletSheetForm from './components/PalletSheetForm';
import PalletSheetView from './components/PalletSheetView';
import DropdownManagement from './components/DropdownManagement';
import GrowerManagement from './components/GrowerManagement';
import EmailRecipientManagement from './components/EmailRecipientManagement';
import Reports from './components/Reports';
import AdminHub from './components/AdminHub';
import AuditLogs from './components/AuditLogs';
import KioskCheckIn from './components/KioskCheckIn';
import StaffManagement from './components/StaffManagement';
import AttendanceDaily from './components/AttendanceDaily';
import AttendanceReport from './components/AttendanceReport';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pallets"
            element={
              <ProtectedRoute>
                <PalletSheets />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pallets/new"
            element={
              <ProtectedRoute allowedRoles={['warehouse_manager', 'admin']}>
                <PalletSheetForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pallets/:id"
            element={
              <ProtectedRoute>
                <PalletSheetView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pallets/:id/edit"
            element={
              <ProtectedRoute allowedRoles={['warehouse_manager', 'admin']}>
                <PalletSheetForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dropdowns"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <DropdownManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/growers"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <GrowerManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/email-recipients"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <EmailRecipientManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminHub />
              </ProtectedRoute>
            }
          />
          <Route
            path="/audit"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AuditLogs />
              </ProtectedRoute>
            }
          />
          <Route path="/kiosk" element={<KioskCheckIn />} />
          <Route
            path="/staff"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <StaffManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance"
            element={
              <ProtectedRoute allowedRoles={['admin', 'warehouse_manager']}>
                <AttendanceDaily />
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/report"
            element={
              <ProtectedRoute allowedRoles={['admin', 'warehouse_manager']}>
                <AttendanceReport />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
